var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVinyl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "i-2187",
    d: "M24,0C10.767,0,0,10.767,0,24s10.767,24,24,24s24-10.767,24-24S37.233,0,24,0z M24,46C11.869,46,2,36.131,2,24 S11.869,2,24,2s22,9.869,22,22S36.131,46,24,46z M24,13c-6.065,0-11,4.935-11,11s4.935,11,11,11s11-4.935,11-11S30.065,13,24,13z M24,33c-4.963,0-9-4.037-9-9s4.037-9,9-9s9,4.037,9,9S28.963,33,24,33z M24,36.333v2c-7.903,0-14.333-6.43-14.333-14.333h2 C11.667,30.801,17.199,36.333,24,36.333z M38.333,24h-2c0-6.801-5.532-12.334-12.333-12.334v-2 C31.903,9.666,38.333,16.097,38.333,24z M24,39.667v2c-9.741,0-17.667-7.926-17.667-17.667h2C8.333,32.639,15.361,39.667,24,39.667z M41.667,24h-2c0-8.639-7.028-15.666-15.667-15.666v-2C33.741,6.334,41.667,14.259,41.667,24z M24,43v2C12.421,45,3,35.579,3,24h2 C5,34.477,13.523,43,24,43z M45,24h-2c0-10.477-8.523-19-19-19V3C35.579,3,45,12.421,45,24z M24,21c-1.654,0-3,1.346-3,3 s1.346,3,3,3s3-1.346,3-3S25.654,21,24,21z M24,25c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S24.552,25,24,25z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-2187"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinyl);
export default __webpack_public_path__ + "static/media/vinyl.682db3bbb1503d488829882b0449f323.svg";
export { ForwardRef as ReactComponent };